import { render, staticRenderFns } from "./deleteCityArea.vue?vue&type=template&id=be98f54e"
import script from "./deleteCityArea.vue?vue&type=script&lang=js"
export * from "./deleteCityArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports